import { Component, OnInit, OnDestroy } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { KycService } from '@app/core/kyc.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { QuestionControlService } from '@app/core/question-control.service';
import { QuestionService } from '@app/core/question.service';
import { QuestionBase } from '@app/core/models/question/question-base';
import { Subscription } from 'rxjs/Subscription';
import { detectDevices } from '@app/core/utils';
import * as utils from '@app/core/utils';
import { NATIONALITIES } from '@app/core/constants';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { SubmitDialogComponent } from '../../shared/submit-dialog/submit-dialog.component';
import * as _ from 'lodash';
import { environment } from 'environments/environment';
import * as moment from 'moment';
declare var $;

@Component({
  selector: 'app-save',
  templateUrl: './save.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class SaveComponent implements OnInit, OnDestroy {
  savingText: string;
  tcLink;
  buttonStyle;
  isDisabledNextButton = true;
  saveForm: FormGroup;
  formChangesSubcription: Subscription;
  isMobileOrTablet: any;
  isShowNationality = false;
  isErrorEmail: boolean = false;
  dialogRef;
  countryCode: string;
  citizenType = [
    { key: 'Singaporean', title: 'Singaporean' },
    { key: 'PR', title: 'Singapore Permanent Resident' },
    { key: 'Foreigner', title: 'Foreigner' }
  ];
  nationalities = NATIONALITIES;
  valueNationality: string;
  textColor: string = "#2bcdb5";
  headerColor: string = "#4d4d4d";
  isQuickKyc = environment.isQuickKyc;
  isWhatsAppRegister = false;
  isSingpassProfile = false;
  fullName = '';
  dateOfBirth = '';
  genderQuestion: QuestionBase<any> = {
    key: 'gender',
    label: 'I am a',
    order: 2,
    required: false,
    controlType: 'radio',
    type: 'radio',
    className: 'c-gender',
    value: 1,
    options: [
      { value: 1, checked: false, classIcon: 'icon-ic_male', name: 'male' },
      { value: 0, checked: false, classIcon: 'icon-ic_female', name: 'female' }
    ]
  } as QuestionBase<any>;
  constructor(
    private kycService: KycService,
    private router: Router,
    private questionService: QuestionService,
    private questionControlService: QuestionControlService,
    private toastrService: ToastrService,
    public dialog: MatDialog
  ) { }
  //Validators.pattern('[a-zA-Z]\d{7}[a-zA-Z]')

  ngOnInit() {
    let rs = this.kycService.kycInfo;
    this.isWhatsAppRegister = this.kycService.isWhatsAppRegister;
    this.tcLink = rs.TcLink || 'http://www.my-insurer.net/term--conditions-users.html';
    if (rs.ButtonBackgroundColor) {
      this.buttonStyle = { 'backgroundColor': rs.ButtonBackgroundColor }
    }
    if (rs.ButtonTextColor) {
      this.buttonStyle = { ...this.buttonStyle, 'color': rs.ButtonTextColor }
    }
    this.textColor = rs.IconColor || this.textColor;
    this.headerColor = rs.HeaderColor || this.headerColor;
    const { save } = this.kycService.kyc;
    if (save.completed) {
      let tenant = this.kycService.getTenant();
      this.router.navigateByUrl('/' + tenant + '/journey/thank-you');
    }
    this.savingText = 'Submit';
    this.countryCode = '65'; //default countryCode = 65 Singapore.
    const questionaire = this.questionService.buildSaveQuestionnaire(save.save);
    const form = this.questionControlService.toFormGroup(questionaire);

    if (!this.kycService.kyc.profile.userProfile) {
      this.kycService.kyc.profile.userProfile = {
        age: 0,
        countrycode: '',
        email: '',
        gender: '',
        kids: 0,
        marital: 0,
        smoked: 0
      } as any;
    }

    this.isSingpassProfile = !!this.kycService.customerProfile;
    const cp = this.kycService.customerProfile || {} as any;
    const p = this.kycService.kyc.profile.userProfile || {} as any;
    this.fullName = this.isSingpassProfile
      ? (cp.FullName || [cp.FirstName, cp.LastName].filter(Boolean).join(' '))
      : ([p.firstName, p.lastName].filter(Boolean).join(' ')
        || [form.controls['FirstName'].value, form.controls['LastName'].value].filter(Boolean).join(' '));
    const currentDob = this.isSingpassProfile ? cp.DateOfBirth : this.kycService.kyc.profile.dob;
    this.dateOfBirth = this.formatDateOfBirth(
      currentDob || (this.isWhatsAppRegister ? moment().subtract(38, 'years') : null)
    );
    const genderLabel = (cp.GenderLabel || '').toString().toUpperCase();
    const singpassGender = cp.Gender === true || genderLabel === 'MALE' ? 1 : 0;
    if (this.isSingpassProfile) {
      p.gender = singpassGender;
    }
    this.saveForm = new FormGroup({
      FullName: new FormControl(
        { value: this.fullName, disabled: this.isSingpassProfile },
        Validators.required
      ),
      DateOfBirth: new FormControl(
        { value: this.dateOfBirth, disabled: this.isSingpassProfile },
        Validators.required
      ),
      phone: new FormControl(
        this.kycService.kyc.profile.userProfile.phone ? this.kycService.kyc.profile.userProfile.phone : (form.controls['phone'].value || ''),
        Validators.required
      ),
      gender: new FormControl(p.gender),
      //Nric: new FormControl(form.controls['Nric'].value || '', [
      //  Validators.required
      //]),

      //NumberOfRooms: new FormControl(
      //  form.controls['NumberOfRooms'].value || '',
      //  Validators.required
      //)
    });
    if (!this.isWhatsAppRegister) {
      this.saveForm.addControl(
        "email",
        new FormControl(
          this.kycService.kyc.profile.userProfile.email || '',
          Validators.email
        ));
    }

    if (!this.isQuickKyc) {
      this.saveForm.addControl(
        "Postcode",
        new FormControl(
          form.controls['Postcode'].value || '',
          Validators.required
        ));

      this.saveForm.addControl(
        "Nationality",
        new FormControl(
          form.controls['Nationality'].value || '',
          Validators.required
        ));
      this.saveForm.addControl(
        "CitizenType",
        new FormControl('', Validators.required
        ));
    }
    else {
      this.saveForm.addControl(
        "Nationality",
        new FormControl(
          form.controls['Nationality'].value || 'Singaporean',
          Validators.required
        ));
    }

    this.isMobileOrTablet = detectDevices();
    this.kycService.getNationalityList().subscribe(res => {
      this.nationalities = res.data.Content[0].Data;
      this.kycService.kyc.save.NATIONALITIES = res.data.Content[0].Data;
    });

    const smokedValue = Number(this.kycService.kyc.profile.userProfile.smoked) === 1 ? 100 : 0;
    _.map(this.kycService.kyc.lifestyle.lifestyle[0].questionRaws, item => {
      if (item.key === 'iSmoke') item.value = smokedValue;
    });
  }

  onCountryChange(obj) {
    //console.log('country code = ', obj.dialCode);
    this.countryCode = obj.dialCode;
  }

  hasError(obj) {
    //console.log('has Error = ', obj);
  }

  onIsShowInterests() {
    const marital = Number(this.kycService.kyc.profile.userProfile.marital);
    const kids = Number(this.kycService.kyc.profile.userProfile.kids);
    if (marital === 0 || kids !== 0) {
      return true;
    } else {
      if (marital === 1 && kids !== 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  closeDropdown(event, element) {
    if (!element.contains(event.target)) {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
      }
    }
  }

  onCheck(checked: any) {
    if (checked) {
      this.isDisabledNextButton = false;
    } else {
      this.isDisabledNextButton = true;
    }
  }

  saveData() {
    if (this.isDisabledNextButton) {
      return;
    }
    if (this.saveForm.valid) {
      this.dialogRef = this.dialog.open(SubmitDialogComponent, {
        width: '300px',
        position: { top: '150px' },
        disableClose: true,
        hasBackdrop: true
      });

      this.isDisabledNextButton = true;

      // sync latest form values into kyc model at save time
      const fv = this.saveForm.getRawValue();
      const name = this.splitFullName(fv.FullName);
      this.kycService.kyc.save.save.forEach((q: any) => {
        if (q.key === 'FirstName') {
          q.value = name.firstName;
        } else if (q.key === 'LastName') {
          q.value = name.lastName;
        } else if (fv.hasOwnProperty(q.key)) {
          q.value = fv[q.key];
        }
      });
      const up = this.kycService.kyc.profile.userProfile;
      up.firstName = name.firstName;
      up.lastName = name.lastName;
      up.countrycode = this.countryCode;
      up.gender = Number(fv.gender);
      this.kycService.kyc.profile.dob = moment(fv.DateOfBirth, 'YYYY-MM-DD', true).toString();
      if (!this.isWhatsAppRegister) {
        if (fv.email) { up.email = fv.email; }
        if (fv.phone) { up.phone = fv.phone; }
      }

      let { email } = this.kycService.kyc.profile.userProfile;
      if (this.isWhatsAppRegister) {
        email = `${this.kycService.kyc.profile.userProfile.countrycode}${this.saveForm.value.phone}`;
      }
      this.kycService.validEmailClient(email).subscribe(
        res => {
          if (res.data.Content[0].Data === false) {
            this.isErrorEmail = false;
            this.kycService.saveKyc(this.kycService.kyc).subscribe(
              response => {
                const info = response.data.Info;
                this.dialogRef.close();
                if (info['Result'] === 'OK') {
                  this.kycService.kyc.complete();
                  this.kycService.kyc.profile.customerId =
                    response.data.Content[0].Data['customerId'];
                  // clear Singpass profile after successful save so it won't be reused
                  try {
                    this.kycService.customerProfile = null;
                  } catch (e) { }
                  let tenant = this.kycService.getTenant();
                  this.router.navigateByUrl('/' + tenant + '/journey/thank-you');
                } else {
                  if (info['Result'] === 'ERROR'
                    && info['ErrorCode'] === -240008) {
                    this.handleError(info['Message']);
                    return;
                  }

                  this.handleError('Internal Server Error');
                }
              },
              error => {
                this.handleError(error);
              }
            );
          } else {
            this.isErrorEmail = true;
          }
        },
        error => {
          this.handleError(error);
        }
      );
    } else {
      utils.markFormGroupTouched(this.saveForm as any);
      this.saveForm.updateValueAndValidity();
      const firstInvalid = utils.findFirstInvalidControlName(this.saveForm as any);
      if (firstInvalid) {
        const el = document.querySelector(`[formcontrolname="${firstInvalid}"]`) as HTMLElement;
        if (el && typeof el.focus === 'function') el.focus();
      }
    }
  }

  handleError(error) {
    this.dialogRef.close();
    this.isDisabledNextButton = false;
    this.toastrService.error(error, 'Submit fail!');
  }

  ngOnDestroy() {
    if (this.formChangesSubcription) { this.formChangesSubcription.unsubscribe(); }
  }

  handleKeyPress(event) {
    this.valueNationality = event.target.value.toLowerCase();
  }
  onDefaultValueNationality(key) {
    if (key !== 'Singaporean') {
      if (this.saveForm.value.Nationality === 'Singaporean') {
        this.saveForm.patchValue({
          Nationality: ''
        });
      }
      this.isShowNationality = true;
    } else {
      this.saveForm.patchValue({
        Nationality: 'Singaporean'
      });
      this.isShowNationality = false;
    }
  }
  onNationalityListClick() {
    this.scrollToNationality(this.saveForm.value.Nationality);
    if (
      !$('#nationalityListWrapper')
        .parent()
        .hasClass('open')
    ) {
      $('#nationalityListWrapper')
        .parent()
        .addClass('open');
    }
  }

  scrollToNationality(value) {
    if (value) {
      const heighOfItem = this.isMobileOrTablet ? 23 : 26;
      const indexOfDefaultNationality = this.nationalities.findIndex(item => {
        return item['title'] === value;
      });
      const scrollNationality = document.getElementById('scrollbars');

      setTimeout(() => {
        scrollNationality.scrollTop =
          heighOfItem * indexOfDefaultNationality - heighOfItem * 2;
      }, 0);
    }
  }

  onClickNation(nationality: string) {
    if (nationality) {
      this.saveForm.patchValue({
        Nationality: nationality
      });
    }
    if (nationality === 'Singaporean') {
      this.saveForm.patchValue({
        CitizenType: 'Singaporean'
      });
    } else {
      this.saveForm.patchValue({
        CitizenType: 'Foreigner'
      });
    }

    if (
      $('#nationalityListWrapper')
        .parent()
        .hasClass('open')
    ) {
      $('#nationalityListWrapper')
        .parent()
        .removeClass('open');
    }
  }

  telInputObj: any;

  telInputObject(obj) {
    this.telInputObj = obj;
    // Singpass flow: pre-fill visible widget with existing phone value
    try {
      const initialPhone = this.saveForm && this.saveForm.get('phone') && this.saveForm.get('phone').value;
      if (initialPhone) {
        obj.setNumber(initialPhone);
        // setNumber does not trigger (input) or ng2TelOutput, so explicitly set hidden control
        const ctrl = this.saveForm && this.saveForm.get('phone');
        const local = this.normalizeLocalPhone(initialPhone);
        if (ctrl && local) {
          ctrl.setValue(local);
          ctrl.updateValueAndValidity();
        }
        if (local && this.kycService && this.kycService.kyc && this.kycService.kyc.profile) {
          this.kycService.kyc.profile.userProfile.phone = local;
        }
      }
    } catch (e) { }
  }

  onPhoneInput() {
    try {
      if (!this.telInputObj || !this.saveForm) return;
      const num = this.telInputObj.getNumber ? this.telInputObj.getNumber() : '';
      const local = this.normalizeLocalPhone(num);
      const ctrl = this.saveForm.get('phone');
      if (ctrl) {
        ctrl.setValue(local);
        ctrl.updateValueAndValidity();
      }
      if (this.kycService && this.kycService.kyc && this.kycService.kyc.profile && this.kycService.kyc.profile.userProfile) {
        this.kycService.kyc.profile.userProfile.phone = local;
      }
    } catch (e) { }
  }

  getNumber(obj) {
    // ng2TelOutput backup — also syncs hidden control when the widget fires its output event
    try {
      const phoneControl = this.saveForm && this.saveForm.get('phone');
      if (phoneControl && obj) {
        const local = this.normalizeLocalPhone(obj);
        phoneControl.setValue(local);
        phoneControl.updateValueAndValidity();
        if (this.kycService && this.kycService.kyc && this.kycService.kyc.profile && this.kycService.kyc.profile.userProfile) {
          this.kycService.kyc.profile.userProfile.phone = local;
        }
      }
    } catch (e) { }
  }

  private normalizeLocalPhone(input: string): string {
    if (!input) return '';
    let s = input.toString().trim();
    s = s.replace(/[^\d+]/g, '');
    if (s.startsWith('+')) s = s.substring(1);
    if (s.startsWith('00')) s = s.replace(/^0+/, '');
    s = s.replace(/[^\d]/g, '');
    if (s.startsWith('65') && s.length > 8) s = s.replace(/^65/, '');
    return s;
  }

  private splitFullName(fullName: string): { firstName: string, lastName: string } {
    const nameParts = (fullName || '').trim().split(/\s+/).filter(Boolean);
    return {
      firstName: nameParts.shift() || '',
      lastName: nameParts.join(' ')
    };
  }

  private formatDateOfBirth(value: any): string {
    if (!value) return '';
    const strictDate = moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
    const date = strictDate.isValid() ? strictDate : moment(value);
    return date.isValid() ? date.format('YYYY-MM-DD') : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/features/save/save.component.ts